export enum ClientTables {
  // FIXME: should be renamed. Name does not describe function of this enum.
  A5_DATA_UPLOAD = "a5_data_upload",
  A6_DATA_UPLOAD = "a6_data_upload",
  C3_DATA_UPLOAD = "c3_data_upload",
  C5_DATA_UPLOAD = "c5_data_upload",
  D1_DATA_UPLOAD = "d1_data_upload",
  GROUP_USERS = "Group Users",
  L1_DATA_UPLOAD = "l1_data_upload",
  M2_DATA_UPLOAD = "m2_data_upload",
  N1_DATA_UPLOAD = "n1_data_upload",
  QTL_STRATEGIES = "strategies",
  S1_DATA_UPLOAD = "s1_data_upload",
  S1_DOWNLOAD_CENTER = "s1_download_center",
  S1_META_DATA = "s1_metadata",
  S3_DATA_UPLOAD = "s3_data_upload",
  S3_DOWNLOAD_CENTER = "s3_download_center",
}
